import React, { cloneElement, isValidElement } from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../inline-image/inline-image.js';
import { TextEditor } from '../text-editor/text-editor.js';
import { InstructionsForUseProperties } from './instructions-for-use-types.js';
import './instructions-for-use.css';
function InstructionsForUseIcon(props) {
    if (!props.icon) {
        return null;
    }
    const className = classNames({
        'c-instructions-for-use__icon': true,
        [`${props.className}`]: Boolean(props.className),
    });
    if (isValidElement(props.icon)) {
        const elementProps = {
            ...props.icon.props,
            className,
        };
        return cloneElement(props.icon, elementProps);
    }
    return React.createElement(InlineImage, { className: className, src: props.icon });
}
function InstructionsForUse(props) {
    const { instructionsForUse, logoIcon = InstructionsForUseProperties.logoIcon.defaultValue, productName, } = props;
    return (React.createElement("div", { className: "c-instructions-for-use" },
        React.createElement("div", { className: "c-instructions-for-use__header" },
            React.createElement(InstructionsForUseIcon, { className: "c-instructions-for-use__logo", icon: logoIcon }),
            React.createElement("div", { className: "c-instructions-for-use__name" }, MessageService.translate(productName))),
        React.createElement("div", { className: "c-instructions-for-use__content" },
            React.createElement(TextEditor, { textOnly: true, value: instructionsForUse }))));
}
export { InstructionsForUse, };
//# sourceMappingURL=instructions-for-use.js.map